import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import classnames from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { icons, colors, sizes, font, pickerStates, positions, textAlignments, hoverStyles } from "../../../enums";
import Header from "../../core/header";
import Icon from "../../core/icon";
import Media from "../../core/media";
import Hoverable from "../../core/hoverable";
import EmptyState from "../../core/empty-state";
import Tooltip from "../../core/tooltip";
import "../../../util/velocity";
import { VelocityComponent } from 'velocity-react';
var Picker = createComponent({
  displayName: 'Picker',
  refs: 'pickerItemRef',
  propTypes: {
    pickerState: PropTypes.oneOf(pickerStates.ALL),
    emptyState: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({
      header: PropTypes.string,
      byline: PropTypes.string
    })]),
    items: PropTypes.arrayOf(PropTypes.shape({
      topline: PropTypes.string,
      header: PropTypes.string,
      byline: PropTypes.string,
      icon: PropTypes.element,
      //<Icon />
      assetRef: PropTypes.string,
      value: PropTypes.any,
      key: PropTypes.string,
      textAlign: PropTypes.oneOf(_.without(textAlignments.ALL, textAlignments.JUSTIFIED)),
      tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
        text: PropTypes.string,
        position: PropTypes.oneOf(positions.ALL)
      })]),
      width: PropTypes.string,
      height: PropTypes.string,
      margin: PropTypes.string,
      isCircular: PropTypes.bool,
      isDisabled: PropTypes.bool
    })).isRequired,
    onSelect: PropTypes.func.isRequired,
    selectedValue: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.oneOfType[(PropTypes.string, PropTypes.number)])]),
    allowMultiple: PropTypes.bool,
    isCentered: PropTypes.bool,
    hoverStyle: PropTypes.oneOfType([PropTypes.oneOf(hoverStyles.ALL), PropTypes.shape({
      style: PropTypes.oneOf(hoverStyles.ALL),
      opacity: PropTypes.number
    })])
  },
  defaultProps: {
    pickerState: pickerStates.DEFAULT,
    emptyState: undefined,
    selectedValue: undefined,
    isCentered: true,
    hoverStyle: hoverStyles.OVERLAY,
    allowMultiple: false
  },
  state: {
    currentSelectedValue: {
      // currentSelectedValue needs to be an array. This ensures the case.
      value: function value(p) {
        var _context;

        return _concatInstanceProperty(_context = []).call(_context, p.selectedValue);
      },
      updater: 'setCurrentSelectedValue'
    }
  },
  handlers: {
    handleOnSelect: function handleOnSelect(p) {
      return function (e, _ref) {
        var value = _ref.value;

        if (p.allowMultiple) {
          var _context2;

          var isIncluded = _includesInstanceProperty(_).call(_, p.currentSelectedValue, value);

          var updatedArray = isIncluded ? _filterInstanceProperty(_).call(_, p.currentSelectedValue, function (item) {
            return item !== value;
          }) : _concatInstanceProperty(_context2 = []).call(_context2, p.currentSelectedValue, [value]);
          p.setCurrentSelectedValue(updatedArray);
          if (p.onSelect) p.onSelect(e, {
            value: updatedArray
          });
        } else {
          p.setCurrentSelectedValue([value]);
          if (p.onSelect) p.onSelect(e, {
            value: value
          });
        }
      };
    }
  },
  lifecycles: {
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.selectedValue !== nextProps.selectedValue) {
        var _context3;

        var updatedSelectedValue = _concatInstanceProperty(_context3 = []).call(_context3, nextProps.selectedValue);

        this.props.setCurrentSelectedValue(updatedSelectedValue);
      }
    },
    componentDidUpdate: function componentDidUpdate(prevProps) {
      if (this.props.pickerState !== prevProps.pickerState && this.props.pickerState === pickerStates.ERROR) {
        this.props.refs.pickerItemRef.runAnimation();
      }
    }
  },
  render: function render(p) {
    var _context4;

    var _isEmpty = _.isEmpty(p.items);

    var _hoverStyle = typeof p.hoverStyle === 'string' ? p.hoverStyle : p.hoverStyle.style;

    var _opacity = typeof p.hoverStyle === 'string' ? undefined : p.hoverStyle.opacity;

    var _cls = classnames('ck picker', {
      centered: p.isCentered,
      isHoverable: _hoverStyle !== hoverStyles.NONE,
      empty: _isEmpty
    });

    return /*#__PURE__*/React.createElement("div", {
      className: _cls
    }, _isEmpty && !_.isNil(p.emptyState) ? /*#__PURE__*/React.createElement(PickerEmpty, {
      emptyState: p.emptyState
    }) : /*#__PURE__*/React.createElement("div", {
      className: "picker__inner"
    }, _mapInstanceProperty(_context4 = p.items).call(_context4, function (item, i) {
      return _includesInstanceProperty(_).call(_, p.currentSelectedValue, item.value) ? /*#__PURE__*/React.createElement(VelocityComponent, {
        key: item.key || item.value || i,
        ref: p.setPickerItemRef,
        animation: "callout.shake"
      }, /*#__PURE__*/React.createElement(PickerItem, {
        value: item.value,
        icon: item.icon,
        assetRef: item.assetRef,
        textAlign: item.textAlign,
        topline: item.topline,
        header: item.header,
        byline: item.byline,
        tooltip: item.tooltip,
        height: item.height,
        width: item.width,
        margin: item.margin,
        isSelected: _includesInstanceProperty(_).call(_, p.currentSelectedValue, item.value),
        isCircular: item.isCircular,
        isDisabled: item.isDisabled,
        hoverStyle: _hoverStyle,
        opacity: _opacity,
        onSelect: p.handleOnSelect,
        itemState: _includesInstanceProperty(_).call(_, p.currentSelectedValue, item.value) && p.pickerState || pickerStates.DEFAULT
      })) : /*#__PURE__*/React.createElement(PickerItem, {
        key: item.key || item.value || i,
        value: item.value,
        icon: item.icon,
        assetRef: item.assetRef,
        textAlign: item.textAlign,
        topline: item.topline,
        header: item.header,
        byline: item.byline,
        tooltip: item.tooltip,
        height: item.height,
        width: item.width,
        margin: item.margin,
        isSelected: _includesInstanceProperty(_).call(_, p.currentSelectedValue, item.value),
        isCircular: item.isCircular,
        isDisabled: item.isDisabled,
        hoverStyle: _hoverStyle,
        opacity: _opacity,
        onSelect: p.handleOnSelect,
        itemState: _includesInstanceProperty(_).call(_, p.currentSelectedValue, item.value) && p.pickerState || pickerStates.DEFAULT
      });
    }, this)));
  }
});
var PickerItem = createComponent({
  displayName: 'PickerItem',
  defaultProps: {
    isCircular: false,
    isDisabled: false,
    opacity: 0.76
  },
  handlers: {
    handleSelect: function handleSelect(p) {
      return function (e) {
        if (p.onSelect && !p.isDisabled) p.onSelect(e, {
          value: p.value
        });
      };
    }
  },
  render: function render(p) {
    var _cls = classnames('picker-item', {
      selected: p.isSelected,
      error: p.itemState === pickerStates.ERROR,
      'hover-underline': p.hoverStyle === hoverStyles.UNDERLINE,
      circular: p.isCircular,
      disabled: p.isDisabled
    });

    logger.warn('Picker PropType error: you may specify either an assetRef or an icon for an item, but not both', !!p.assetRef && !!p.icon);

    var _assetDimensions = p.assetRef ? getAssetDimensions({
      assetRef: p.assetRef,
      height: p.height,
      width: p.width
    }) : {
      width: p.width,
      height: p.height
    };

    var _hoverableOpacity = p.itemState !== pickerStates.DEFAULT || p.isSelected ? 0 : p.opacity;

    return /*#__PURE__*/React.createElement(ItemTooltip, {
      tooltip: p.tooltip,
      isDisabled: p.isDisabled
    }, /*#__PURE__*/React.createElement("div", {
      className: _cls,
      style: {
        margin: p.margin,
        width: _assetDimensions.width
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "picker-item__inner"
    }, p.hoverStyle === hoverStyles.OVERLAY ? /*#__PURE__*/React.createElement(Hoverable, {
      color: colors.ACCENT,
      opacity: _hoverableOpacity,
      isCircular: p.isCircular,
      display: "block"
    }, /*#__PURE__*/React.createElement(SimpleItem, {
      itemState: p.itemState,
      icon: p.icon,
      assetRef: p.assetRef,
      width: _assetDimensions.width,
      height: _assetDimensions.height,
      isSelected: p.isSelected,
      handleSelect: p.handleSelect,
      isCircular: p.isCircular,
      opacity: p.opacity
    }), !p.isSelected ? /*#__PURE__*/React.createElement(Hoverable.OnHover, {
      onClick: p.handleSelect,
      value: p.value
    }, /*#__PURE__*/React.createElement("div", {
      className: "picker-item__hover-text"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: icons.APPROVE,
      size: sizes.X2
    }), "SELECT")) : null) : /*#__PURE__*/React.createElement(SimpleItem, {
      itemState: p.itemState,
      icon: p.icon,
      assetRef: p.assetRef,
      width: _assetDimensions.width,
      height: _assetDimensions.height,
      isSelected: p.isSelected,
      handleSelect: p.handleSelect,
      isCircular: p.isCircular,
      opacity: p.opacity
    }), /*#__PURE__*/React.createElement("div", {
      className: "picker-item__content"
    }, p.topline ? /*#__PURE__*/React.createElement("div", {
      className: "picker-item__topline"
    }, /*#__PURE__*/React.createElement(Header, {
      text: p.topline,
      font: {
        emphasis: font.emphasis.NORMAL,
        family: font.families.CUSTOM,
        weight: font.weights.LIGHT
      },
      textAlign: p.textAlign,
      style: {
        padding: 0
      }
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "picker-item__header"
    }, /*#__PURE__*/React.createElement(Header, {
      text: p.header,
      byline: p.byline,
      font: {
        emphasis: font.emphasis.NORMAL,
        family: font.families.CUSTOM,
        weight: font.weights.MEDIUM
      },
      textAlign: p.textAlign
    }))))));
  }
});
var SimpleItem = createComponent({
  displayName: 'SimpleItem',
  render: function render(p) {
    var _classnames;

    var _itemStateCls = classnames('picker-item__item-state', (_classnames = {}, _classnames["picker-item__item-state--" + p.itemState] = p.itemState, _classnames));

    var _itemOpacity = p.isSelected || p.itemState === pickerStates.ERROR || p.itemState === pickerStates.LOADING ? p.opacity : 0;

    return /*#__PURE__*/React.createElement("div", {
      className: "picker-item__item-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: _itemStateCls,
      onClick: p.handleSelect,
      style: {
        opacity: _itemOpacity
      }
    }, p.itemState === pickerStates.ERROR ? /*#__PURE__*/React.createElement(Icon, {
      name: icons.CANCEL,
      size: sizes.X8
    }) : p.isSelected && p.itemState !== pickerStates.LOADING ? /*#__PURE__*/React.createElement(Icon, {
      name: icons.APPROVE,
      size: sizes.X8
    }) : null), /*#__PURE__*/React.createElement("div", {
      className: "picker-item__item-image",
      onClick: p.handleSelect,
      style: {
        width: p.width,
        height: p.height
      }
    }, p.assetRef ? /*#__PURE__*/React.createElement(Media, {
      reference: p.assetRef,
      size: {
        width: p.width,
        height: p.height
      },
      style: {
        objectFit: 'cover'
      },
      isCircular: p.isCircular
    }) : p.icon));
  }
}); // utility components

var getAssetDimensions = function getAssetDimensions(_ref2) {
  var _ref2$assetRef = _ref2.assetRef,
      assetRef = _ref2$assetRef === void 0 ? '' : _ref2$assetRef,
      width = _ref2.width,
      height = _ref2.height;
  var _dimensions = assetRef.split(':')[2];
  return {
    width: width || _dimensions.split('x')[0] + "px" || 'auto',
    height: height || _dimensions.split('x')[1] + "px" || 'auto'
  };
}; // empty state


var PickerEmpty = function PickerEmpty(_ref3) {
  var emptyState = _ref3.emptyState;
  return /*#__PURE__*/React.isValidElement(emptyState) ? emptyState : /*#__PURE__*/React.createElement(EmptyState, {
    textAlign: textAlignments.CENTER,
    header: emptyState.header,
    byline: emptyState.byline
  });
}; // choose how we are going to wrap the tooltip around an item


var ItemTooltip = function ItemTooltip(_ref4) {
  var tooltip = _ref4.tooltip,
      children = _ref4.children,
      isDisabled = _ref4.isDisabled;
  return typeof tooltip === 'undefined' ? children : typeof tooltip === 'string' ? /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: tooltip,
    isInline: false,
    isDisabled: isDisabled
  }, children) : /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: tooltip.text,
    position: tooltip.position,
    isDisabled: isDisabled,
    isInline: false
  }, children);
};

export default Picker;
//# sourceMappingURL=index.js.map